import { createSlice } from '@reduxjs/toolkit';

import { DELAY } from '../../config';
// ! detect language from Browser Preferences
var userLang = navigator.language || navigator.userLanguage;
let onlyTwoLetters = 'fr' || userLang.slice(0, 2);
console.log(onlyTwoLetters);
export const langueSlice = createSlice({
    name: 'langue',
    initialState: {
        value: onlyTwoLetters,
    },
    reducers: {
        setLang2Fr: (state) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            console.log(state);
            state.value = 'fr';
        },
        setLang2Eng: (state) => {
            console.log(state);
            state.value = 'en';
        },
        incrementByAmount: (state, action) => {
            state.value += action.payload;
        },
    },
});

export const { setLang2Fr, setLang2Eng, incrementByAmount } = langueSlice.actions;

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
export const incrementAsync = (amount) => (dispatch) => {
    setTimeout(() => {
        dispatch(incrementByAmount(amount));
    }, DELAY);
};

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectLang = (state) => state.langue.value;

export default langueSlice.reducer;

